import { useEffect, useRef } from "react";

/**
 * Keep the keyboard-highlighted option inside a scrollable suggestions list
 * without scrolling ancestor containers (e.g. Filters modal).
 */
export default function useScrollActiveOptionIntoView(activeIndex) {
  const listRef = useRef(null);
  const activeOptionRef = useRef(null);

  useEffect(() => {
    const list = listRef.current;
    const option = activeOptionRef.current;

    if (!list || !option) {
      return;
    }

    const listRect = list.getBoundingClientRect();
    const optionRect = option.getBoundingClientRect();

    if (optionRect.bottom > listRect.bottom) {
      list.scrollTop += optionRect.bottom - listRect.bottom;
    } else if (optionRect.top < listRect.top) {
      list.scrollTop -= listRect.top - optionRect.top;
    }
  }, [activeIndex]);

  return { listRef, activeOptionRef };
}
